import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image,
  Box,
  Text
} from '@chakra-ui/react';
import CloseModalIcon from '../../../../assets/close-modal-icon.svg';
import Button from '../../../Button';
import UserCard from '../../../Profile/user-card';
import RequestCard from '../../../CreateRequest/components/request-card.component';
import InformIcon from '../../../../assets/inform-green-icon.svg';
import RenderMedia from '../../../MediaContainer/media.component';
import DeleteIcon from '../../../../assets/bin-red-icon.svg';
import { TooltipComponent } from '../../../Tooltip';

const EQUITY_PERCENTAGE_TOOLTIP =
  "The percentage of equity you have proposed. This information has been shared with the writer for their review.  If your response is approved by the writer, you will share this percentage of the article's equity. This means you’ll be credited as a contributors and share in its success.";

function ViewResponseDetailModal(props) {
  const { isOpen, onSubmit, onClose, bgColorOverlay, data, onDelete } = props;

  const convertStatus = (row) => {
    let text = '';
    let textColor = '';
    let bgColor = '';
    let fontWeight = 0;
    switch (row.status) {
      case 'rejected': {
        text = 'Rejected';
        textColor = '#FFFFFF';
        bgColor = '#DE1414';
        fontWeight = 800;
        break;
      }
      case 'approved': {
        text = 'Accepted';
        textColor = '#FFFFFF';
        bgColor = '#4CAF50';
        fontWeight = 800;
        break;
      }
      case 'pending': {
        text = 'Pending';
        textColor = '#204A22';
        bgColor = '#EDF7EE';
        fontWeight = 600;
        break;
      }
      default: {
      }
    }
    return (
      <Box py={'1.5px'} px={'12px'} rounded={'80px'} bgColor={bgColor} w={'fit-content'}>
        <Text color={textColor} fontSize={'xs'} fontWeight={fontWeight}>
          {text}
        </Text>
      </Box>
    );
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent
        maxW={'708px'}
        maxH={{ base: '80vh', md: '90vh' }}
        p={'24px'}
        bgColor={'#FAFAFA'}
        rounded={'12px'}
      >
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">My response details</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onSubmit}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody px={{ base: 0, md: '10px' }} py={0} overflowY={'scroll'}>
          <div className="mt-6 mb-2">
            <p className="font-[800]">Requester:</p>
            <div className="mt-[8px] p-[10px] border border-growth-green-300 rounded-[10px]">
              <UserCard user={data?.request?.user} avatarSize={'w-[40px] h-[40px]'} />
              <div className="my-[8px] border-b border-earth-brown-50"></div>
              <RequestCard
                request={data?.request}
                showStatus={true}
                tooltips={'The percentage of equity the client has proposed.'}
              />
            </div>
          </div>
          <div className="mb-[10px] md:border-b border-earth-brown-50"></div>
          <div className="">
            <p className="font-[800] ">Your response:</p>
            <div className="my-[8px]">
              <div className="grid grid-rows-[auto,auto,auto] gap-[10px]">
                <div className="flex items-center gap-[5px]">
                  <span className="text-growth-green-500 text-sm flex items-center gap-[5px]">
                    Your Proposed Equity
                    <TooltipComponent description={EQUITY_PERCENTAGE_TOOLTIP} Icon={InformIcon} />:
                  </span>
                  <span className="text-sm">{data?.equityPercentage}%</span>
                </div>
                <div className="flex items-center gap-[5px]">
                  <span className="text-growth-green-500 text-sm flex items-center gap-[5px]">
                    Response Status :
                  </span>
                  {convertStatus(data)}
                </div>
                <div className="text-sm">
                  <p className="font-[800] text-base inline ">Title: </p>
                  {data?.title}
                </div>
                <div className="text-justify">
                  <p className="font-[800]">Notes: </p>
                  <p className="text-sm">{data?.note}</p>
                </div>
                <div className="flex items-center gap-[5px]">
                  <span className="font-[800] inline">Content:</span>
                  <Box px={'12px'} rounded={'80px'} bgColor={'#F0EDEC'} w={'fit-content'}>
                    <Text color={'#6A4E42'} fontWeight={800} fontSize={'xs'}>
                      {data?.contentTypes[0]?.name}
                    </Text>
                  </Box>
                </div>
                <RenderMedia type={data?.contentTypes[0]?.name} url={data?.contentUrl} />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter w="100%" p={0}>
          {data?.status !== 'pending' ? (
            <Button onClick={onSubmit} className="w-full h-[42px] ">
              Done
            </Button>
          ) : (
            <div className="flex flex-col md:flex-row justify-end gap-[10px] mt-4 w-full">
              <Button
                onClick={() => {
                  onDelete(data?.id);
                }}
                variant="red-outline"
                className="w-full md:w-fit whitespace-nowrap h-[42px]"
              >
                Delete response
                <img
                  src={DeleteIcon}
                  className="ml-[5px] cursor-pointer"
                  alt="icon"
                  onClick={() => {}}
                />
              </Button>
              <Button onClick={onSubmit} className="w-full md:w-[146px] h-[42px] ">
                Done
              </Button>
            </div>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ViewResponseDetailModal;
